"use client";

import { ICMSConcurso } from "@/services/types";
import RenderHtmlContentDescriptions from "../common/RenderHtmlContentDescritpions";
import { HighLightTitleHeading } from "../common/HighLightTitleCermiHeading";

interface ResultadosConcursoSectionProps {
    concurso: ICMSConcurso;
}

const ResultadosConcursoSection: React.FC<ResultadosConcursoSectionProps> = ({ concurso }) => {

    return (
        <section className="relative w-full mx-auto container p-4 sm:p-6 md:p-8 lg:p-12 xl:p-16">

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-12 sm:mb-16 lg:mb-20">

                <div className="flex ">
                    <HighLightTitleHeading title={concurso.title_resultados_concurso || ""} />
                </div>

                {/** description resultado section */}
                <div className="w-full px-4 sm:px-4 lg:px-16 py-6">
                    {concurso.description_resultados_concurso && <RenderHtmlContentDescriptions htmlContent={concurso.description_resultados_concurso} className=" font-normal text-xl mb-6" />}
                </div>
            </div>
        </section>);
};

export default ResultadosConcursoSection;